const entities = ['plot', 'monster', 'encounter', 'rumour', 'lammie', 'research', 'ritual', 'systemPage']
export default Object.freeze(entities)
